/**
 * @generated SignedSource<<a2449af604e73b0f53e5f19d1648d4bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupTemplateOptions_moduleGroup$data = {
  readonly flow: {
    readonly name: string;
    readonly rowId: UUID;
    readonly " $fragmentSpreads": FragmentRefs<"TemplatesFavorite_flow">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AssignGroupTemplate">;
  readonly " $fragmentType": "GroupTemplateOptions_moduleGroup";
};
export type GroupTemplateOptions_moduleGroup$key = {
  readonly " $data"?: GroupTemplateOptions_moduleGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTemplateOptions_moduleGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupTemplateOptions_moduleGroup",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssignGroupTemplate"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "gwtUserId",
              "variableName": "gwtUserId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "TemplatesFavorite_flow"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ModuleGroup",
  "abstractKey": null
};

(node as any).hash = "8fb60badc95be385306f97180ab3ee28";

export default node;
